import React from 'react';
import SyncIcon from '@mui/icons-material/Sync';
import makeStyles from '@mui/styles/makeStyles';
import { Typography, LinearProgress } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme: any) => ({
  submissionSuccessContainer: {
    lineHeight: 'normal',
    display: 'flex',
    padding: theme.spacing(1.3, 0),
    borderRadius: theme.spacing(0.5)
  },
  successBanner: {
    flex: 1
  },
  outerContainer: {
    borderTop: `1px solid ${theme.palette.grey[300]}`
  },
  syncInformation: {
    padding: theme.spacing(0.2, 0.2),
    ...theme.typography.caption,
    color: theme.palette.grey[900],
    backgroundColor: theme.palette.grey[500],
    marginRight: theme.spacing(1.5),
    fontSize: 22,
    float: 'right',
    borderRadius: '50%'
  }
}));

export const CollectorSyncing: React.FC = () => {
  const classes = useStyles();
  return (
    <div
      className={classes.outerContainer}
      data-testid="syncing-success-dialog"
    >
      <div className={classes.submissionSuccessContainer}>
        <SyncIcon
          data-testid="syncIcon-testid"
          className={classes.syncInformation}
        />
        <Typography
          className={classes.successBanner}
          data-testid="syncingBanner"
          align="left"
          variant="body2"
        >
          <FormattedMessage
            id={'collectorSetting.details.syncingProjectsMessage'}
          />
        </Typography>
      </div>
      <LinearProgress data-testid="syncingProgress" />
    </div>
  );
};
